export default {"src":"/_next/static/media/SpotIllustration.e3f216a5.svg","height":260,"width":260,"blurWidth":0,"blurHeight":0};